import React from 'react';

/*
    - ihoDesignSystem
*/
import { Box, Image, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import InfoSVG from '../../../assets/images/help-desk/info.svg';
import UserSVG from '../../../assets/images/help-desk/user.svg';

const Shared = ({ createTicketResut, requestType, selectedReserve, ticket }) => {

    return (

        <React.Fragment>

            {(requestType.split(',')[4] === 'modifyRoomFinished' || requestType.split(',')[4] === 'cancelFinished' || requestType.split(',')[4] === 'modifyDateFinished' || requestType.split(',')[4] === 'extraPassengerFinished' || requestType.split(',')[4] === 'halfChargeFinished' || requestType.split(',')[4] === 'modifyPassengerFinished' || requestType.split(',')[4] === 'transferFinished') &&
                <React.Fragment>
                    <Box
                      className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-dark)'
                            }}>
                            {requestType.split(',')[4] === 'modifyRoomFinished' &&
                                <Typography
                                    className={`d-block`}
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    تایید و ارسال درخواست تغییر و یا حذف اتاق
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'cancelFinished' &&
                                <Typography
                                    className={`d-block`}
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    تایید و ارسال درخواست کنسل کردن رزرو
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'modifyDateFinished' &&
                                <Typography
                                    className={`d-block`}
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    تایید و ارسال درخواست تغییر تاریخ رزرو
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'extraPassengerFinished' &&
                                <Typography
                                    className={`d-block`}
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    تایید و ارسال درخواست افزودن نفر اضافه
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'halfChargeFinished' &&
                                <Typography
                                    className={`d-block`}
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    تایید و ارسال درخواست افزودن نیم شارژ
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'modifyPassengerFinished' &&
                                <Typography
                                    className={`d-block`}
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    تایید و ارسال درخواست تغییر اطلاعات مسافران
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'transferFinished' &&
                                <Typography
                                    className={`d-block`}
                                    ms={{
                                        color: 'var(--white)'
                                    }}>
                                    تایید و ارسال درخواست ترنسفر
                                </Typography>
                            }
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                    <Box
                       className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '0.5s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm  rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)',
                            }}>
                            <Typography>
                                درخواست شما با موفقیت ارسال گردید.
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                      className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '1s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`w-75 px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)',
                                opacity: '0',
                                bottom: '-16px',
                                animation: 'chatAnimation 0.25s linear',
                                animationFillMode: 'forwards',
                                animationDelay: '0.5s'
                            }}>
                            <Typography>
                                لازم به ذکر است، ارسال درخواست به منزله تایید نهایی نبوده و پس از پیگیری کارشناسان ما، نتیجه از طریق پیامک به شما اعلام خواهد شد.
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                       className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '1.5s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)',
                            }}>
                            <Typography
                                className={`d-block`}>
                                کد درخواست : {createTicketResut}
                            </Typography>
                            <Typography
                                className={`d-block`}>
                                کد رزرو : {selectedReserve.nuRequest}
                            </Typography>
                            {requestType.split(',')[4] === 'modifyRoomFinished' &&
                                <Typography
                                    className={`d-block`}>
                                    نوع درخواست
                                    :
                                    تغییر یا حذف اتاق
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'cancelFinished' &&
                                <Typography
                                    className={`d-block`}>
                                    نوع درخواست
                                    :
                                    کنسل کردن رزرو
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'modifyDateFinished' &&
                                <Typography
                                    className={`d-block`}>
                                    نوع درخواست
                                    :
                                    تغییر تاریخ رزرو
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'extraPassengerFinished' &&
                                <Typography
                                    className={`d-block`}>
                                    نوع درخواست
                                    :
                                    افزودن نفر اضافه
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'halfChargeFinished' &&
                                <Typography
                                    className={`d-block`}>
                                    نوع درخواست
                                    :
                                    افزودن نیم شارژ
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'modifyPassengerFinished' &&
                                <Typography
                                    className={`d-block`}>
                                    نوع درخواست
                                    :
                                    تغییر اطلاعات مسافران
                                </Typography>
                            }
                            {requestType.split(',')[4] === 'transferFinished' &&
                                <Typography
                                    className={`d-block`}>
                                    نوع درخواست
                                    :
                                    ترنسفر
                                </Typography>
                            }
                            <Typography
                                className={`d-block`}>
                                خلاصه درخواست : {ticket}
                            </Typography>
                        </Box>
                    </Box>
                </React.Fragment>
            }

        </React.Fragment>

    );

}

export default Shared;